import { Badge } from "@hortis/ui/badge";
import { IconButton } from "@hortis/ui/button";
import { Dialog, DialogTrigger } from "@hortis/ui/dialog";
import { XClose } from "@hortis/ui/icons";
import {
  useGetUserSettingsQuery,
  useUpdateUserSettingsMutation,
} from "generated/graphql";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { ReleaseNoteDialogContent } from "./release-note-dialog-content";
import { useReleaseNote } from "./use-release-note";

export const ReleaseNoteCard = () => {
  const [hideBanner, setHideBanner] = useState(false);
  const [{ data }] = useGetUserSettingsQuery();
  const [_, updateUserSettings] = useUpdateUserSettingsMutation();
  const { releaseNote } = useReleaseNote("revamped-records");

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- false positive
  const settings = data?.userSettings?.settings;
  const showBanner =
    !hideBanner &&
    settings != null &&
    settings["hideRevampedRecordsBanner"] !== true;

  const updateBannerHidden = async () => {
    setHideBanner(true);
    await updateUserSettings({
      input: { settings: { hideRevampedRecordsBanner: true } },
    });
  };

  return releaseNote == null ? undefined : (
    <Dialog>
      <div className={twMerge("relative", showBanner ? "block" : "hidden")}>
        <DialogTrigger
          className="w-full overflow-hidden rounded-lg bg-grey-100/80 text-left outline-hidden ring-grey-200/70 transition hover:bg-grey-100 focus-visible:ring-4"
          onClick={updateBannerHidden}
        >
          <div className="space-y-1 p-3">
            <Badge className="px-1.5 py-px">New</Badge>
            <div className="flex items-center justify-between gap-3 text-sm font-medium text-grey-900">
              Revamped records
            </div>
            <p className="text-xs text-grey-500">
              Redesigned page layouts for clarity and faster access to key data
            </p>
          </div>
        </DialogTrigger>
        <IconButton
          variant="linkgray"
          icon={<XClose className="h-4 w-4" />}
          ariaLabel="Close release note"
          className="absolute right-4 top-4"
          onClick={updateBannerHidden}
        />
      </div>
      <ReleaseNoteDialogContent releaseNote={releaseNote} />
    </Dialog>
  );
};
